/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AssignmentStatus = {
    Open: 'Open',
    Completed: 'Completed'
} as const;
export type AssignmentStatus = typeof AssignmentStatus[keyof typeof AssignmentStatus];


export function instanceOfAssignmentStatus(value: any): boolean {
    for (const key in AssignmentStatus) {
        if (Object.prototype.hasOwnProperty.call(AssignmentStatus, key)) {
            if (AssignmentStatus[key as keyof typeof AssignmentStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AssignmentStatusFromJSON(json: any): AssignmentStatus {
    return AssignmentStatusFromJSONTyped(json, false);
}

export function AssignmentStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentStatus {
    return json as AssignmentStatus;
}

export function AssignmentStatusToJSON(value?: AssignmentStatus | null): any {
    return value as any;
}

export function AssignmentStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AssignmentStatus {
    return value as AssignmentStatus;
}

